<template>
  <div class="input-group">
    <span id="basic-addon1" class="input-group-text"
      ><i class="fas fa-search"></i
    ></span>
    <input
      v-model.lazy="currentSearchText"
      :placeholder="placeholderText"
      type="text"
      class="form-control"
      @keyup.enter="enterSearch"
    />
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      placeholderText: this.placeholder || this.$t("label.search"),
      currentSearchText: "",
    }
  },
  watch: {
    placeholder(value) {
      this.placeholderText = value
    },
  },
  mounted() {
    this.placeholderText = this.placeholder || this.$t("label.search")
  },
  methods: {
    enterSearch() {
      this.$emit("search", this.currentSearchText)
    },
  },
}
</script>

<style lang="scss" scoped>
.input-group {
  &-text {
    background: $white;
    border-right: none;
    border-radius: 25px 0 0 25px;
    line-height: 40px;
  }
  .form-control {
    font-size: 14px;
    font-weight: 500;
    color: #616161;
    line-height: 1.87;
    border: 1px solid #ced4da;
    border-left: none;
    border-radius: 0 25px 25px 0;
    padding: 0px;
    height: 34px;
  }
}
</style>
